import { type SxProps } from "@mui/material";

export const baseModalStyles: Record<string, SxProps> = {
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 600,
    bgcolor: "background.paper",
    borderRadius: 1,
  },
  header: {
    p: 2,
  },
  content: {
    p: 2,
    maxHeight: "70vh",
    overflowY: "auto",
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 1,
  },
};
